import { http } from "@/http";

export default {
  // list(data, params) {
  //   const allParams = { ...data, ...params };
  //   return http.get("/api/v1/vehicles", { params: allParams });
  // },
  list(data, params) {
    return http.post('/api/v1/vehicles/list', data, {params})
  },
  save(data) {
    return http.post("/api/v1/vehicles", data);
  },
  get(id) {
    return http.get(`/api/v1/vehicles/${id}`);
  },
  update(id, data) {
    return http.put(`/api/v1/vehicles/${id}`, data);
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/vehicles/${id}/status`, null, {
      params: { status },
    });
  },
};
